import Vue from 'vue'
import Router from 'vue-router'
import auth from './middlewares/auth';
import bitacora from './middlewares/bitacora';
import disabled from './middlewares/disabled';
import store from './store';

Vue.use(Router)

const router = new Router({
  mode: 'history', routes: [
    {
      path: '/Login',
      component: () => import('@/views/Login.vue'),
      name: 'Login'
    },
    {
      path: '/',
      component: () => import('@/views/Home.vue'),
      name: 'Inicio',
      meta: {
        middleware: [auth, bitacora],
      },
    },
    {
      path: '/ActualizaContrasena',
      component: () => import('@/views/ActualizarContrasena.vue'),
      name: 'Actualizar Contraseña',
      meta: {
        middleware: [auth, bitacora],
      },
    },
    {
      path: '/ActualizaCorreo',
      component: () => import('@/views/ActualizarCorreo.vue'),
      name: 'Actualizar Correo',
      meta: {
        middleware: auth,
      }
    },
    {
      path: '/VerAvisos',
      component: () => import('@/views/VerAvisos.vue'),
      name: 'Ver Avisos',
      meta: {
        middleware: [auth, bitacora],
      },
    },
    {
      path: '/MisPromociones/:codOpcion',
      component: () => import('@/views/ProyectoPE/MisPromociones/BandejaMisPromocionesSolicitadas.vue'),
      name:'Mis promociones',
      meta: {
        middleware: [auth, bitacora],
      },
    },
    {
      path: '/AutorizacionPE/:codOpcion',
      component: () => import('@/views/ProyectoPE/InicioComun/BandejaPromocionesSolicitadas.vue'),
      name:'Autorización de Promoción Empresarial',
      meta: {
        middleware: [auth, bitacora, disabled],
      },
    },
    //**** BANDEJA COMUN INICIAL SOLICITADOS  INICIO ******/
    {
      path: '/AmpliacionModificacion/:codOpcion',
      component: () => import('@/views/ProyectoPE/InicioComun/BandejaComun.vue'),
      name: 'Ampliacion Modificacion',
      meta: {
        middleware: [auth, bitacora],
      },
    },
    {
      path: '/Desistimiento/:codOpcion',
      component: () => import('@/views/ProyectoPE/InicioComun/BandejaComun.vue'),
      name: 'Desistimiento',
      meta: {
        middleware: [auth, bitacora],
      },
    },
    {
      path: '/Renuncia/:codOpcion',
      component: () => import('@/views/ProyectoPE/InicioComun/BandejaComun.vue'),
      name: 'Renuncia',
      meta: {
        middleware: [auth, bitacora],
      },
    },
    {
      path: '/DocumentosPosteriores/:codOpcion',
      component: () => import('@/views/ProyectoPE/InicioComun/BandejaComun.vue'),
      name: 'Documentos Posteriores',
      meta: {
        middleware: [auth, bitacora],
      },
    },
    {
      path: '/InclusionExclusion/:codOpcion',
      component: () => import('@/views/ProyectoPE/InicioComun/BandejaComun.vue'),
      name: 'Inclusion Exclusión',
      meta: {
        middleware: [auth, bitacora],
      },
    },
    {
      path: '/AclaracionComplementacionEnmienda/:codOpcion',
      component: () => import('@/views/ProyectoPE/InicioComun/BandejaComun.vue'),
      name: 'Aclaracion Complementacion Enmienda',
      meta: {
        middleware: [auth, bitacora],
      },
    },
    //**** BANDEJA COMUN INICIAL SOLICITADOS  FIN ******/

    {
      path: '/SeguimientoTramite',
      component: () => import('@/views/ProyectoPE/SeguimientoTramite.vue'),
      name: 'Seguimiento De Tramites',
      meta: {
        middleware: [auth, bitacora],
      },
    },
    {
      path: '/Comun/ListadoPromociones/:codOpcion',
      component: () => import('@/views/ProyectoPE/InicioComun/BandejaSeleccionPromocion.vue'),
      name:'Listado de Promociones',
      meta: {
        middleware: [auth, bitacora],
      },
    },
    //******* FORMULARIOS
    {
      path: '/Formulario/Formulario1000/:tramite_id?',
      component: () => import('@/views/ProyectoPE/PromocionesEmpresariales/FormPromocionesEmpresariales.vue'),
      name: 'Formulario Autorización',
      meta: {
        middleware: [auth, bitacora],
      },
    },
    {

      path: '/Formulario/Formulario1001/:idPromocion/:idTramite?',
      component: () => import('@/views/ProyectoPE/AmpliacionModificacion/FormAmpliacionModificacion.vue'),
      name: 'Formulario Ampliacion y/o Modificación',
      meta: {
        middleware: [auth, bitacora],
      },
    },
    {

      path: '/Formulario/Formulario1002/:idPromocion/:idAmpliacion?',
      component: () => import('@/views/ProyectoPE/Desistimiento/FormDesistimiento.vue'),
      name: 'Formulario Desistimiento',
      meta: {
        middleware: [auth, bitacora],
      },
    },
    {
      path: '/Formulario/Formulario1003/:idPromocion',
      component: () => import('@/views/ProyectoPE/AclaracionComplementacionEnmienda/FormAclaracionComplementacionEnmienda.vue'),
      name: 'Formulario Aclaración Complementación Enmienda',
      meta: {
        middleware: [auth, bitacora],
      },
    },
    {
      path: '/Formulario/Formulario1004/:idPromocion',
      component: () => import('@/views/ProyectoPE/InclusionExclusion/FormInclusionExclusion.vue'),
      name: 'Formulario Inclusión Exclusión',
      meta: {
        middleware: [auth, bitacora],
      },
    },
    {
      path: '/Formulario/Formulario1005/:idPromocion',
      component: () => import('@/views/ProyectoPE/DocumentosPosteriores/FormDocumentosPosteriores.vue'),
      name: 'Formulario Documentos Posteriores',
      meta: {
        middleware: [auth, bitacora],
      },
    },
    {
      path: '/Formulario/Formulario1010/:idPromocion',
      component: () => import('@/views/ProyectoPE/Renuncia/FormRenuncia.vue'),
      name: 'Formulario Renuncia',
      meta: {
        middleware: [auth, bitacora],
      },
    },
    {
      path: '/Formulario/FormularioSolicitudCredenciales',
      component: () => import('@/views/SolicitudCredenciales.vue'),
      name: 'Formulario Solicitud Credenciales',
    },
    {
      path: '/Formulario/EnvioDocumentosSolicitudCredenciales/:codigo',
      component: () => import('@/views/EnvioDocumentosSolicitudCredenciales.vue'),
      name: 'Envio Documentos Solicitud Credenciales',
    },
    {
      path: '/ValidacionCorreo',
      component: () => import('@/views/ValidacionCorreoElectronico.vue'),
      name: 'ValidateEmail'
    },
    {
      path: '/SorteadorAJ',
      component: () => import('@/views/SorteadorAJ.vue'),
      name: 'Formulario para Acceder a sorteador'
    },
    //***** Fin FORMULARIO */

    //{ path: "*", redirect: '/' }
  ]
})

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {

    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];

    const context = {
      from,
      next,
      router,
      to,
      store
    };

    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();

});

export default router;
